export default __webpack_public_path__ + "cc34fde461497e588f400defd673a065.png";